import I18n from 'I18n';
import { ANALYTICS_SUITE_TAB_IDS, NAV_KEYS, SMART_LIBRARY_PATHS } from './types/navigation';
import { Routes } from './Routes';
import { useEffect, useRef } from 'react';
import { getActiveNavItem } from './utils/navigationUtils';
import { useHistory, useLocation } from 'react-router-dom';
import { HeaderContainer } from './containers/HeaderContainer';
import { SideNav } from 'foundations-components/transitional/components/SideNav';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SmartLibraryContainer = () => {
  const history = useHistory();
  const {
    pathname
  } = useLocation();
  const activeNavItem = getActiveNavItem(pathname);
  const containerRef = useRef(null);
  useEffect(() => {
    var _containerRef$current;
    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.children[0]) {
      containerRef.current.children[0].scrollIntoView();
    }
  }, [pathname]);
  return /*#__PURE__*/_jsx("div", {
    ref: containerRef,
    children: /*#__PURE__*/_jsx(ListingPage, {
      pageLayout: "full-width",
      sidebarAreaFlush: true,
      headerComponent: /*#__PURE__*/_jsx(HeaderContainer, {}),
      sidebarComponent: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsxs(SideNav, {
          value: activeNavItem,
          children: [/*#__PURE__*/_jsx(SideNavItem, {
            value: NAV_KEYS.USER_LIBRARY,
            title: I18n.text('smartLibrary.sideNav.myLibrary'),
            onClick: () => {
              history.push(SMART_LIBRARY_PATHS.USER_LIBRARY);
            }
          }), /*#__PURE__*/_jsx(SideNavItem, {
            value: NAV_KEYS.ANALYTICS_SUITE,
            title: I18n.text('smartLibrary.sideNav.analyticsSuite'),
            onClick: () => {
              history.push(`${SMART_LIBRARY_PATHS.ANALYTICS_SUITE}/${ANALYTICS_SUITE_TAB_IDS.DISCOVER}`);
            }
          })]
        })
      }),
      children: /*#__PURE__*/_jsx(Routes, {})
    })
  });
};